import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbcaa4f0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bbcaa4f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcaa4f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CkIcon: require('/opt/build/repo/components/Ck/Icon/index.js').default})
